<template>
  <main role="main">
    <b-container fluid="xxl" class="py-4 d-flex flex-row overflow-hidden">
      <div class="flex-grow-1">
        <h4 class="mb-3">{{ $t("editMeeting") }}</h4>

        <div v-if="isLoading" class="py-5 text-center">
          <b-spinner/>
        </div>

        <div v-else-if="!activeCustomerSubscription" class="py-5 text-center">
          {{ $t("noActiveSub") }}
        </div>

        <b-form v-else id="edit-meeting-form" @submit.prevent="submitForm">
          <b-form-row class="align-items-center border-top pt-4 mb-3">
            <b-col cols="3"><label for="input-name">{{ $t("meetingName") }} <span class="text-danger">(*)</span></label></b-col>
            <b-col cols="9">
              <b-form-input id="input-name" v-model="name" type="text"
                            required minlength="2" maxlength="150"></b-form-input>
            </b-col>
          </b-form-row>
          <b-form-row class="mb-3">
            <b-col cols="3" class="align-self-center">
              <label>{{ $t("datetime") }} <span class="text-danger">(*)</span></label>
            </b-col>
            <b-col cols="4">
              <b-form-datepicker v-model="startDate" value-as-date required
                                 :state="startDateValidationStatus"
                                 :min="new Date()"
                                 no-flip hide-header
                                 label-no-date-selected="DD/MM/YYYY"
                                 locale="vi"
                                 :date-format-options="datePickerFormatOptions"
                                 start-weekday="1"></b-form-datepicker>
              <b-form-invalid-feedback :state="startDateValidationStatus">
                {{ $t("pleaseSelectValidDate") }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col cols="1" style="align-self: center; text-align: center; flex: 0 0 4.33333333%; max-width: 4.33333333%; "><b-icon icon="dash"/></b-col>
            <b-col cols="2" style="flex: 0 0 18.66666667%; max-width: 18.666667%;">
              <b-select :options="hourOptions" v-model="startHour" required></b-select>
            </b-col>
            <b-col cols="2" style="flex: 0 0 18.66666667%; max-width: 18.666667%;">
              <b-select :options="minuteOptions" v-model="startMinute" required></b-select>
            </b-col>
          </b-form-row>
          <b-form-row class="align-items-center mb-3">
            <b-col cols="3"><label>{{ $t("meetingDuration") }} <span class="text-danger">(*)</span></label></b-col>
            <b-col cols="9">
              <b-form-row>
                <b-col cols="3" class="d-flex flex-row align-items-center">
                  <b-select :options="durationHourOptions" v-model="durationHour" required
                            :state="durationValidationStatus"></b-select>
                  <div class="mx-2">{{ $t("hours") }}</div>
                </b-col>
                <b-col cols="3" class="d-flex flex-row align-items-center">
                  <b-select :options="durationMinuteOptions" v-model="durationMinute" required
                            :state="durationValidationStatus"></b-select>
                  <div class="mx-2">{{ $t("minutes") }}</div>
                </b-col>
                <b-col cols="6" class="d-flex flex-row align-items-center">
                  <span class="text-secondary">({{ $t("maximum") }} {{ maxDurationStr }})</span>
                </b-col>
              </b-form-row>
              <b-form-invalid-feedback :state="durationValidationStatus">
                {{ $t("meetingDurationFormFeedback") }} {{ maxDurationStr }}
              </b-form-invalid-feedback>
            </b-col>
          </b-form-row>
          <!--<b-form-row class="align-items-center mb-3">
            <b-col cols="3">
              <label for="input-num-participants">Số người tham gia <span class="text-danger">*</span></label>
            </b-col>
            <b-col cols="3">
              <b-form-input id="input-num-participants" v-model="numOfParticipants" type="number"
                            required min="2" :max="subscriptionPlanMaxParticipantsCount"></b-form-input>
            </b-col>
            <b-col cols="6">
              <span class="text-secondary mr-1">(Tối đa {{ subscriptionPlanMaxParticipantsCount }} người)</span>
              <span title="Theo giới hạn của gói cước bạn đang sử dụng" v-b-tooltip.hover>
                <b-icon icon="info-circle"/>
              </span>
            </b-col>
          </b-form-row>-->
          <b-form-row class="align-items-center mb-4">
            <b-col cols="3">
              <label for="input-access-code">{{ $t("accessCode") }} <span class="text-danger">(*)</span></label>
            </b-col>
            <b-col cols="3">
              <b-input-group>
                <b-form-input id="input-access-code" v-model="accessCode" type="text"
                              class="text-monospace custom-validity-fix"
                              required minlength="6" maxlength="12" autocomplete="off" pattern="^[A-Za-z0-9]+$"
                              @invalid="$event.target.setCustomValidity($t('accessCodeFormFeedback'))"
                              @input.native="$event.target.setCustomValidity('')"></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-secondary" v-b-tooltip :title="$t('createRandomAccessCode')"
                            @click="setRandomAccessCode">
                    <b-icon-arrow-repeat/>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-form-row>
          <!-- <b-form-row class="align-items-center border-bottom pb-4 mb-4">
            <b-col cols="3"><label for="radio-group-public-meeting">{{ $t("accessPermission") }}</label></b-col>
            <b-col cols="9">
              <b-form-radio-group
                id="radio-group-public-meeting" v-model="publicMeeting"
                :options="isPublicMeetingOptions" required></b-form-radio-group>
            </b-col>
          </b-form-row> -->
          <!-- <b-form-row class="align-items-center mb-4">
            <b-col cols="3"><label for="radio-group-public-meeting"></label></b-col>
            <b-col cols="9">
              <b-form-radio-group
                id="radio-group-public-meeting" v-model="publicMeeting"
                :options="isPublicMeetingOptions" required></b-form-radio-group>
              <label for="" style="margin-left: 24px; color: #626262; font-size: 14px;">{{ $t("privateSub1") }}</label>
                 <label for="" style="margin-left: 24px; color: #626262; font-size: 14px;">{{ $t("privateSub2") }}</label>
            </b-col>
          </b-form-row> -->

          <b-form-row class="align-items-center mb-4">
            <b-col cols="3"><label>{{ $t("meetingOperator") }} <span class="text-danger">(*)</span></label></b-col>
            <b-col cols="9">
              <b-form-row v-for="(participant, i) of operators" :key="i">
                <b-form-group class="col-4 width-input">
                  <template v-if="i === 0" v-slot:label>{{ $t("fullName") }} <span class="text-danger">(*)</span></template>
                  <v-select class="vs-normalizer" label="label"
                            :clearable="false"
                            :filterable="false"
                            :options="participant.typeaheadOptions"
                            :clearSearchOnBlur="() => false"
                            :clearSearchOnSelect="false"
                            @search="participant.doSearchDebounced"
                            v-on:option:selecting="participant.onTypeaheadSelecting">
                    <template v-slot:search="{attributes, events}">
                      <input v-bind="attributes" v-on="events" v-model="participant.name"
                             :placeholder="$t('namePlaceHolder')"
                             class="form-control" required minlength="2" maxlength="100"/>
                    </template>
                  </v-select>
                </b-form-group>
                <b-form-group class="col-4 width-input">
                  <template v-if="i === 0" v-slot:label>Email <span class="text-danger">(*)</span></template>
                  <b-form-input class="custom-validity-fix" type="email" v-model="participant.email"
                                :placeholder="$t('emailPlaceHolder')"
                                required maxlength="100" :state="participant.emailValidationState"/>
                </b-form-group>
                <b-form-group class="col-4 width-input">
                  <template v-if="i === 0" v-slot:label>{{ $t("phoneNumber") }}</template>
                  <b-form-input class="custom-validity-fix" type="tel" v-model="participant.phone"
                                :pattern="phonePattern" maxlength="50"
                                :placeholder="$t('phonePlaceHolder')"
                                @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                                @input.native="$event.target.setCustomValidity('')"/>
                </b-form-group>
                <b-form-group class="col-4 width-action">
                  <template v-if="i === 0" v-slot:label>&nbsp; </template>
                  <div class="contact-form-extra">
                    <span class="text-primary cursor-pointer"
                          @click="onClickPickContact(participant)">{{ $t("contact") }}</span>
                    <span class="text-danger cursor-pointer" v-if="operators.length >= 2"
                          @click="onClickDeleteOperator(i)">{{ $t("actionDelete") }}</span>
                  </div>
                </b-form-group>
              </b-form-row>
            </b-col>
          </b-form-row>
          <b-form-row class="align-items-center mb-1">
            <b-col cols="3"><label for="radio-group-public-meeting"></label></b-col>
            <b-col cols="9">
              <!-- <b-form-radio-group
                id="radio-group-public-meeting" v-model="publicMeeting"
                :options="isPublicMeetingOptions" required></b-form-radio-group> -->
              <b-form-row>
                <b-col cols="3" class="d-flex flex-row align-items-center  width-input">
                  <b-form-checkbox
                    id="radio-group-public-meeting"
                    v-model="privateMeeting"
                    @change="checkboxMeeting"
                  >
                    {{ $t("meetingTypeClosed") }}
                    <b-icon icon="exclamation-circle" shift-v="4" class="icon-info"
                    v-b-tooltip.hover="{ customClass: 'tooltip-class', placement: 'bottom', title: $t('privateSub1') }"></b-icon>
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" class="d-flex flex-row align-items-center" v-if="activeFaceId == 1 && privateMeeting">
                    <b-form-checkbox 
                        v-model="onFaceidForMeeting" name="check-button">
                        {{ $t("joinByFaceId") }}
                        <b-icon icon="exclamation-circle" shift-v="4" class="icon-info"
                          v-b-tooltip.hover="{ customClass: 'tooltip-class', placement: 'bottom', title: $t('faceIdSub') }">
                        </b-icon>
                    </b-form-checkbox>
                </b-col>
              </b-form-row>
            </b-col>
          </b-form-row>
          <b-form-row v-if="privateMeeting" class="form-row pb-4 border-top mb-4 pt-4 mt-4">
            <b-col cols="3" class="mt-4">
              <label>{{ $t("meetingParticipantsList") }} <span class="text-danger">(*)</span></label>
              <div class="text-secondary">({{ $t("meetingParticipantsMaxCount", { count: maxParticipantsCount - 1 }) }})</div>
            </b-col>
            <b-col cols="9">
              <b-form-row v-for="(participant, i) of participants" :key="i">
                <b-form-group class="col-3 width-input">
                  <template v-if="i === 0" v-slot:label>{{ $t("fullName") }} <span class="text-danger">(*)</span></template>
                  <v-select class="vs-normalizer" label="label"
                            :clearable="false"
                            :filterable="false"
                            :options="participant.typeaheadOptions"
                            :clearSearchOnBlur="() => false"
                            :clearSearchOnSelect="false"
                            @search="participant.doSearchDebounced"
                            v-on:option:selecting="participant.onTypeaheadSelecting">
                    <template v-slot:search="{attributes, events}">
                      <input v-bind="attributes" v-on="events" v-model="participant.name"
                             :placeholder="$t('namePlaceHolder')"
                             class="form-control" required minlength="2" maxlength="100"/>
                    </template>
                  </v-select>
                </b-form-group>
                <b-form-group class="col-3 width-input">
                  <template v-if="i === 0" v-slot:label>Email <span class="text-danger">(*)</span></template>
                  <b-form-input class="custom-validity-fix" type="email" v-model="participant.email"
                                :placeholder="$t('emailPlaceHolder')"
                                required maxlength="100" :state="participant.emailValidationState"/>
                </b-form-group>
                <b-form-group class="col-3 width-input">
                  <template v-if="i === 0" v-slot:label>{{ $t("phoneNumber") }}</template>
                  <b-form-input class="custom-validity-fix" type="tel" v-model="participant.phone"
                                :pattern="phonePattern" maxlength="50"
                                :placeholder="$t('phonePlaceHolder')"
                                @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
                                @input.native="$event.target.setCustomValidity('')" />
                </b-form-group>
                <b-form-group class="col-3 width-action">
                  <template v-if="i === 0" v-slot:label>&nbsp; </template>
                  <div class="contact-form-extra">
                    <span class="text-danger cursor-pointer" v-if="participants.length >= 2"
                          @click="onClickDeleteParticipant(i)">{{ $t("actionDelete") }}</span>
                    <img  v-if="onFaceidForMeeting && participant.code && participant.imgUploadStatus == 'SUCCESS'" 
                    src="icon/faceId.svg" width="32px"  height="32px"
                    v-b-tooltip.hover="{ customClass: 'tooltip-class', placement: 'bottom', title: $t('faceIdIconSub') }"/>
                    <img v-if="onFaceidForMeeting && (!participant.code || participant.imgUploadStatus != 'SUCCESS')"
                    src="icon/warning.svg" width="32px"  height="32px"/>
                  </div>
                </b-form-group>
              </b-form-row>
              <div style="display: flex;">
              <div class="mr-4" style="width: fit-content;" v-if="!onFaceidForMeeting">
                <span v-if="participantsCount < maxParticipantsCount" class="text-primary cursor-pointer"
                        @click="onClickAddParticipant">
                  {{ $t("addMeetingParticipant") }}
                </span>
                <span v-else-if="participantsCount > maxParticipantsCount" class="text-danger">
                  {{ $t("maxMeetingParticipantsExceeded") }}
                </span>
                <span v-else class="text-secondary cursor-pointer">
                  {{ $t("addMeetingParticipant") }}
                </span>
              </div>
                <div>
                  <span class="text-primary cursor-pointer" @click="onClickPickMultipleContacts(participants)">
                    {{ $t("chooseFromContacts") }}
                  </span>
                </div>              
              </div>
            </b-col>
          </b-form-row>

          <b-form-row class="border-top pb-4 mb-4 pt-4 mt-4">
            <b-col cols="3">
              <label>{{ $t("meetingConfig") }}</label>
            </b-col>
            <b-col cols="9">
              <b-form-checkbox v-if="isBBB" v-model="onlyShowCameraForOperator">
                {{ $t("onlyShowCameraForOperator") }}
              </b-form-checkbox>
              <!-- <b-form-checkbox v-if="isBBB" :disabled="!storageInfo.allowRecording" v-model="enableMeetingRecording">
                {{ $t("enableToggleMeetingRecording") }}
              </b-form-checkbox> -->
              <b-form-checkbox :disabled="!storageInfo.allowRecording" v-model="enableAutomaticMeetingRecording">
                {{ $t("enableAutomaticMeetingRecording") }}
              </b-form-checkbox>
              <div v-if="!storageInfo.allowRecording" class="text-danger">
                {{ $t("storageFullAlert", { used: storageInfo.storageUsed, total: storageInfo.storagePlan }) }}
              </div>
              <b-form-checkbox v-if="isBBB" v-model="enableMuteOnStart">
                {{ $t("meetingMuteOnStart") }}
              </b-form-checkbox>
              <b-form-checkbox v-model="enableCamera">
                {{ $t("meetingShareCamera") }}
              </b-form-checkbox>
              <b-form-checkbox v-if="isBBB" v-model="enableMicro">
                {{ $t("enableMicro") }}
              </b-form-checkbox>
              <b-form-checkbox v-if="activeVoiceText == 1" v-model="onVoiceText">
                {{ $t("enableVoiceText") }}
              </b-form-checkbox>
<!--              <b-form-checkbox v-if="isBBB" v-model="enablePrivateChat">
                {{ $t("meetingPrivateChatAllow") }}
              </b-form-checkbox>
              <b-form-checkbox v-if="isBBB" v-model="enablePublicChat">
                {{ $t("meetingPublicChatAllow") }}
              </b-form-checkbox>-->
              <!-- <b-form-checkbox v-if="isBBB" v-model="enableTakingNote">
                {{ $t("enableTakingNote") }}
              </b-form-checkbox> -->
              <b-form-checkbox v-if="isZoom" v-model="enableParticipationBeforeHost">
                {{ $t("enableParticipationBeforeHost") }}
              </b-form-checkbox>
              <!--            <b-form-checkbox v-if="isBBB" v-model="enableSendAttachmentInChat">
                            Cho phép gửi tập tin trong chat
                          </b-form-checkbox>-->
            </b-col>
          </b-form-row>

          <b-form-row :style="{'height': formErrorMsg ? '85px':'38px'}" ref="submitButton">
            <b-col cols="3" ></b-col>
            <b-col :class="{'button-move': !isBottom, 'form-row': !isBottom, 'border-top': !isBottom}" cols="9">
              <b-col cols="3" v-if="!isBottom"></b-col>
              <div :class="{'col-9': !isBottom}">
                <div v-if="formErrorMsg" class="text-danger mb-4" >{{ formErrorMsg }}</div>
                <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("saveChanges") }}</b-button>
              </div>
            </b-col>
          </b-form-row>

        </b-form>
      </div>

      <div style="width: 180px;">
        <!-- Khoảng trống dùng để hiện thị các nút action (danh bạ, xoá) nằm nổi ra bên ngoài -->
      </div>
    </b-container>

    <b-modal id="pick-contact-modal" :title="$t('chooseContact')" ok-only ok-variant="secondary" :ok-title="$t('cancel')">
      <PickContactModal modal-id="pick-contact-modal" @picked="onContactPicked" />
    </b-modal>
    <b-modal id="pick-multiple-contact-modal" :title="$t('chooseContact')" size="xl" hide-footer>
      <PickMultipleContactModal
        modal-id="pick-multiple-contact-modal"
        :p_selected-contacts="pickingMultipleContactArray"
        :onFaceidForMeeting= "onFaceidForMeeting"
        @done="onMultipleContactPicked"
      />
    </b-modal>

  </main>
</template>

<style lang="scss" scoped>
  #edit-meeting-form {
    label {
      margin: 0;
    }

    // .contact-form-extra {
    //   width: 280px;
    //   position: absolute;
    //   right: -10px;
    //   bottom: 8px;
    //   transform: translateX(100%);
    // }
    .contact-form-extra {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      height: calc(1.5em + 0.75rem + 2px);
      align-items: center;
    }
    .width-input {
      flex: 0 0 29%;
      max-width: 29%;
    }

    .width-action {
      flex: 0 0 13%;
      max-width: 13%;
    }

    .button-move {
      bottom: 0px;
      position: fixed !important;
      z-index: 10;
      max-width: 1280px;
      background: white;
      padding: 20px 0px;      
      padding-right: 180px;
    }
    .icon-info {
      margin-left: 6px; 
      font-size: 12px !important;
      color: #004F9E !important;
      pointer-events: fill;
      cursor: pointer;
    }
  }
</style>

<script lang="ts">
  import {Component, Ref} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as util from "@/service/util";
  import * as meetingService from "@/service/meetingService";
  import * as subscriptionPlanService from "@/service/subscriptionPlanService";
  import * as validationUtils from "@/service/validationUtils";
  import PickContactModal from "@/components/contact/PickContactModal.vue";
  import PickMultipleContactModal from "@/components/contact/PickMultipleContactModal.vue";
  import * as contactService from "@/service/contactService";
  import * as userService from "@/service/userService";
  import {DateTime} from "luxon";


  @Component({
    components: { PickContactModal, PickMultipleContactModal }
  })
  export default class EditMeeting extends BaseComponent {

    readonly datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    readonly isPublicMeetingOptions = [
      { text: this.$t("meetingTypeClosed").toString(), value: false },
      { text: this.$t("meetingTypeOpen").toString(), value: true },
    ];

    id: number = null;
    isLoading = false;
    user = userService.getCurrentUser() || null;

    activeVoiceText = this.user.activeVoiceText;
    originalMeeting = null;
    activeFaceId = this.user.activeFaceId;
    onFaceidForMeeting = false;
    onVoiceText = false;

    name = "";
    // numOfParticipants: number | string = null;
    startDate: Date = null;
    startDateValidationStatus: boolean = null;

    startHour: number = null;
    hourOptions = [];

    startMinute: number = null;
    minuteOptions = [];

    durationHour = 1;
    durationHourOptions = [];

    durationMinute = 0;
    durationMinuteOptions = [];

    accessCode = "";
    publicMeeting = false;

    operators = [];
    participants = [];

    onlyShowCameraForOperator = false;
    enableMeetingRecording = true;
    enableAutomaticMeetingRecording = false;
    enableMuteOnStart = true;
    enableCamera = true;
    enableMicro = true;
    enablePrivateChat = true;
    enablePublicChat = true;
    enableTakingNote = true;
    enableParticipationBeforeHost = false;
    enableSendAttachmentInChat = false;

    pickingContact = null;
    pickingMultipleContactArray = [];

    activeCustomerSubscription = null;
    activeSubscriptionPlan = null;
    storageInfo = null;

    formErrorMsg = "";
    isSubmitting = false;

    privateMeeting = false;

    @Ref('submitButton') submitButton!: HTMLDivElement;
    isBottom = true;

    mounted() {
      window.addEventListener('scroll', this.handleScroll);
      this.id = +this.$route.params.id || null;

      this.hourOptions.push({ text: "HH", value: null, disabled: true });

      for (let i = 0; i < 24; i++) {
        this.hourOptions.push({
          text: i.toString().padStart(2, "0"),
          value: i
        });
      }

      this.minuteOptions.push({ text: "mm", value: null, disabled: true });
      for (let i = 0; i < 60; i++) {
        this.minuteOptions.push({
          text: i.toString().padStart(2, "0"),
          value: i
        });
      }

      for (let i = 0; i <= 24; i++) {
        this.durationHourOptions.push(i);
      }

      for (let i = 0; i < 60; i += 15) {
        this.durationMinuteOptions.push(i);
      }

      this.fetchMeeting();
    }

    handleScroll () {   
        let clientHeight = document.documentElement.clientHeight;
        if(this.submitButton) {
          let elementToTop= this.submitButton.getBoundingClientRect().top;
          this.isBottom = clientHeight > elementToTop;      
        }
    }

    checkboxMeeting(value) {
      // this.privateMeeting = value;
      this.handleScroll();
    }

    async fetchMeeting() {
      try {
        this.isLoading = true;

        // Start fetching the original meeting
        const fetchMeetingPromise = meetingService.getDetails(this.id);

        // Fetch customer subscription
        const subscriptions = await subscriptionPlanService.getCustomerSubscription(this.getUserCustomerId());
        this.activeCustomerSubscription = subscriptions.find(it => it.isActive);

        if (this.activeCustomerSubscription) {
          const { subscriptionPlanId } = this.activeCustomerSubscription;
          this.activeSubscriptionPlan = await subscriptionPlanService.getPackageDetail(subscriptionPlanId);

          const maxDurationHours = this.activeSubscriptionPlan.maximumLengthOfOneMeeting / 60;
          _.remove(this.durationHourOptions, it => it > maxDurationHours);
        }

        // Obtain fetching result
        const meeting = await fetchMeetingPromise;

        // Assign props from the original meeting object
        this.name = meeting.name;
        // this.numOfParticipants = meeting.numOfParticipants;
        this.accessCode = meeting.accessCode;

        const startDateTime = DateTime.fromISO(meeting.scheduleStartTime);
        this.startDate = startDateTime.toJSDate();
        this.startHour = startDateTime.hour;
        this.startMinute = startDateTime.minute;

        this.durationHour = Math.floor(meeting.scheduleDuration / 60);
        this.durationMinute = meeting.scheduleDuration % 60;

        this.privateMeeting = !meeting.publicMeeting;
        this.onFaceidForMeeting = meeting.activeFaceId;
        this.onVoiceText = meeting.activeVoiceText;

        const contactItems = meeting.meetingParticipants
          .map(it => Object.assign(
            this.createContactItem(it.role),
            _.pick(it, ["contactId","name", "email", "phone", "code", "imgUploadStatus"])
          ));
        this.operators = contactItems.filter(it => it.role === "OPERATOR");
        this.participants = contactItems.filter(it => it.role !== "OPERATOR");
        
        if (!this.participants.length) {
          this.onClickAddParticipant(); // prevent zero participants
        }

        this.onlyShowCameraForOperator = meeting.onlyShowCameraForOperator;
        this.enableMeetingRecording = meeting.enableMeetingRecording;
        this.enableAutomaticMeetingRecording = meeting.enableAutomaticMeetingRecording;
        this.enableMuteOnStart = meeting.enableMuteOnStart;
        this.enableCamera = meeting.enableCamera;
        this.enableMicro = meeting.enableMicro;
        this.enablePrivateChat = meeting.enablePrivateChat;
        this.enablePublicChat = meeting.enablePublicChat;
        this.enableTakingNote = meeting.enableTakingNote;
        this.enableParticipationBeforeHost = meeting.enableParticipationBeforeHost;

        this.originalMeeting = meeting;

        this.storageInfo = await meetingService.getStoragePlan();
        if (!this.storageInfo.allowRecording) {
          this.enableAutomaticMeetingRecording = false;
          this.enableMeetingRecording = false;
        }

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
        this.handleScroll();
      }
    }

    get isBBB(): boolean {
      return this.activeSubscriptionPlan?.coreImplName?.toLowerCase() === "bbb";
    }

    get isZoom(): boolean {
      return this.activeSubscriptionPlan?.coreImplName?.toLowerCase() === "zoom";
    }

    /**
     * Max num of participants (based on the active subscription)
     */
    get subscriptionPlanMaxParticipantsCount(): number {
      return this.activeSubscriptionPlan?.maximumNumberOfParticipantsInMeeting || 0;
    }

    get maxParticipantsCount(): number {
      return this.activeSubscriptionPlan?.maximumNumberOfParticipantsInMeeting || 0;
    }

    get durationValidationStatus(): boolean {
      const maxDurationMins = this.activeSubscriptionPlan?.maximumLengthOfOneMeeting || 0;
      const durationMins = this.durationHour * 60 + this.durationMinute;
      return (durationMins < 15 || durationMins > maxDurationMins) ? false : null;
    }

    get maxDurationStr(): string {
      const maxDurationMins = this.activeSubscriptionPlan?.maximumLengthOfOneMeeting || 0;
      const hours = Math.floor(maxDurationMins / 60);
      const mins = maxDurationMins % 60;

      return [
        hours > 0 ? hours + " " + this.$t("hours").toString() : undefined,
        mins > 0 ? mins + " " + this.$t("minutes").toString() : undefined
      ].filter(_.identity).join(" ");
    }

    get participantsCount(): number {
      return this.operators.length + this.participants.length;
    }

    setRandomAccessCode() {
      this.accessCode = util.randomStr(6).toUpperCase();
      util.clearCustomValidity();
    }

    createContactItem(role): any {
      const p = {
        name: "",
        phone: "",
        email: "",
        assignedBy: this.userId,
        role,

        emailValidationState: null,
        typeaheadOptions: [],

        doSearchDebounced: _.debounce(async function (q: string, loading: (p: boolean) => void) {
          try {
            if (q.length < 2) {
              p.typeaheadOptions = [];
            } else {
              loading(true);

              // Fetch and assign typeahead options
              p.typeaheadOptions = (await contactService.getAllContacts(1, 10, q)).data;

              // Typeahead option label: "name - department"
              for (const contactOption of p.typeaheadOptions) {
                contactOption.label = [contactOption.name, contactOption.department, contactOption.organization]
                  .map(it => it?.trim())
                  .filter(_.identity)
                  .join(" - ");
              }
            }

          } catch (e) {
            console.error(e);

          } finally {
            loading(false);
          }
        }, 300),

        onTypeaheadSelecting(option) {
          p.name = option.name;
          p.phone = option.phone;
          p.email = option.email;
          util.clearCustomValidity();
        }
      };

      return p;
    }

    onClickAddOperator() {
      this.operators.push(this.createContactItem("OPERATOR"));
    }

    onClickAddParticipant() {
      this.participants.push(this.createContactItem("PARTICIPANT"));
      this.handleScroll();
    }

    onClickDeleteOperator(index: number) {
      this.operators.splice(index, 1);
    }

    onClickDeleteParticipant(index: number) {
      this.participants.splice(index, 1);
    }

    onClickPickContact(contact) {
      this.pickingContact = contact;
      this.$bvModal.show("pick-contact-modal");
    }
    
    onClickPickMultipleContacts(targetArray: any[]) {
      this.pickingMultipleContactArray = targetArray.filter(participant => participant.contactId);
      this.$bvModal.show("pick-multiple-contact-modal");
    }

    onContactPicked(contact) {
      this.pickingContact.name = contact.name;
      this.pickingContact.email = contact.email;
      this.pickingContact.phone = contact.phone;

      // HTMLInputElement doesn't emit "input" event when setting the value programmatically
      // so we need to call setCustomValidity on our own
      util.clearCustomValidity();
    }

    onMultipleContactPicked(contacts: any[]) {
      // delete old
      this.participants = this.participants.filter(p => !p.id && !p.contactId);
      if (contacts.length) {
        this.participants = this.participants.filter(p => ["name", "email", "phone"].some(k => p[k]));
      }
      contacts.forEach(contact => {
        this.convertContactToParticipant(contact);
      })
      // push new
      this.participants.push(...contacts);

      if (!this.participants.length) {
        this.onClickAddParticipant();
      }
      const timeout = setTimeout(() => {
          this.handleScroll();
          clearTimeout(timeout);
        }, 200);      
    }

    convertContactToParticipant(contact) {
      contact.doSearchDebounced = () => {
        return;
      }
      contact.onTypeaheadSelecting = option => {
        return;
      }
    }

    async submitForm() {
      this.startDateValidationStatus = null;
      this.formErrorMsg = null;

      const allParticipants = !this.privateMeeting ? this.operators : [...this.operators, ...this.participants];
      for (const participant of allParticipants) {
        participant.emailValidationState = null;
        participant.contactId = participant.id ? participant.id : participant.contactId;
      }

      if (!this.startDate) {
        this.startDateValidationStatus = false;
        this.formErrorMsg = this.$t("pleaseSelectMeetingStartDate").toString();
        return;
      }

      if (_.isNil(this.startDate) || _.isNil(this.startHour) || _.isNil(this.startMinute)) {
        this.formErrorMsg = this.$t("pleaseSelectMeetingStartDatetime").toString();
        return;
      }

      const startDateTime = DateTime.fromJSDate(this.startDate).set({ hour: this.startHour, minute: this.startMinute });
      if (+startDateTime.diffNow() < 0) {
        this.formErrorMsg = this.$t("invalidMeetingStartDatetime").toString();
        return;
      }

      let hasInvalidParticipantEmail = false;

      for (const participant of allParticipants) {
        if (validationUtils.isEmail(participant.email)) {
          participant.emailValidationState = null;
        } else {
          participant.emailValidationState = false;
          hasInvalidParticipantEmail = true;
        }
      }

      if (hasInvalidParticipantEmail) {
        this.formErrorMsg = this.$t("invalidMeetingOperatorOrParticipantEmail").toString();
        return;
      }

      if (this.participantsCount > this.maxParticipantsCount) {
        this.formErrorMsg = this.$t("maxMeetingParticipantsExceeded").toString();
        return;
      }

      if (this.durationValidationStatus === false) {
        this.formErrorMsg = this.$t("invalidMeetingDurationOrExceededLimit").toString();
        return;
      }

      const data = {
        id: this.id,
        status: this.originalMeeting.status, // Leave it unchanged
        name: this.name,
        numOfParticipants: this.participantsCount,
        scheduleStartTime: startDateTime.toISO(),
        scheduleDuration: this.durationHour * 60 + this.durationMinute,
        operatorPassword: this.accessCode, // redundancy
        accessCode: this.accessCode,
        publicMeeting: !this.privateMeeting,
        onlyShowCameraForOperator: this.isBBB? this.onlyShowCameraForOperator : false,
        enableMeetingRecording: this.isBBB? this.enableMeetingRecording : false,
        enableAutomaticMeetingRecording: this.enableAutomaticMeetingRecording,
        enableMuteOnStart: this.isBBB? this.enableMuteOnStart : false,
        enableCamera: this.enableCamera,
        enableMicro: this.isBBB? this.enableMicro : false,
        enablePrivateChat: this.isBBB? this.enablePrivateChat : false,
        enablePublicChat: this.isBBB? this.enablePublicChat : false,
        enableTakingNote: this.isBBB? this.enableTakingNote : false,
        enableParticipationBeforeHost: this.isZoom? this.enableParticipationBeforeHost : false,
        enableSendAttachmentInChat: this.isBBB? this.enableSendAttachmentInChat : false,
        participants: allParticipants.map(it => _.pick(it, ["contactId", "name", "phone", "email", "assignedBy", "role", "code", "imgUploadStatus"])),
        activeFid: this.onFaceidForMeeting && this.privateMeeting ? 1 : 0,
        activeVoiceText: this.onVoiceText ? 1 : 0,
      };

      try {
        this.isSubmitting = true;
        await meetingService.updateMeeting(data);
        this.$router.push("/meetings/details/" + this.id);
        this.toastSuccessDelay(this.$t("updateSuccessful").toString());

      } catch (e) {
        this.formErrorMsg = this.$t(e.response?.data?.code || e.code).toString();
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
